import { render, staticRenderFns } from "./PasswordPolicyNew.vue?vue&type=template&id=2d8b4b8e"
import script from "./PasswordPolicyNew.vue?vue&type=script&lang=js"
export * from "./PasswordPolicyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports